// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Represents common errors that can occur during an JSON-RPC call.
 * The integer values are used for serialization.
 */
export enum JsonRpcErrorCode
{
  ParseError = -32700,
  InvalidRequest = -32600,
  MethodNotFound = -32601,
  InvalidParameters = -32602,
  InternalError = -32603
}